import { mapGetters, mapState } from 'vuex';

export default {
  methods: {
    calculateCargoLineSpace(cargoLine, margin, areSizesInMetres) {
      var stackLevel = cargoLine.stackLevel < 0 ? 1 : cargoLine.stackLevel;
      if (stackLevel === 0) {
        return 0.0;
      }

      // extra lifts are not stored with dimensions in metres
      //0.3048 is the conversion used in Flow for feet to metres
      if (cargoLine.widthInMetres === null || cargoLine.widthInMetres === undefined
        || cargoLine.lengthInMetres == null || cargoLine.lengthInMetres === undefined) {
        if (!areSizesInMetres) {
          cargoLine.widthInMetres = cargoLine.width * 0.3048;
          cargoLine.lengthInMetres = cargoLine.length * 0.3048;
        }
        else {
          cargoLine.widthInMetres = cargoLine.width;
          cargoLine.lengthInMetres = cargoLine.length;
        }
      }

      if (cargoLine.widthInMetres <= 0 || cargoLine.lengthInMetres <= 0) {
        return 0.0;
      }

      const sizeToAddToWidthAndLength = cargoLine.Quantity > 1 ? 0 : margin;
      return (cargoLine.widthInMetres + sizeToAddToWidthAndLength) * (cargoLine.lengthInMetres + sizeToAddToWidthAndLength) * Math.ceil(cargoLine.quantity / stackLevel);
    },
    getDeckSpaceForActivity(syncedAndUnsyncedVesselActivities, outboundVoyage, inboundVoyage, syncedAndUnsyncedOutboundCargoLines, syncedAndUnsyncedInboundCargoLines) {
      var numActivities = syncedAndUnsyncedVesselActivities.length;

      if (numActivities > 0) {
        const prevActivity = syncedAndUnsyncedVesselActivities[0];
        const { activity } = prevActivity;
        const isCargoActivity = activity ? activity.isCargoHandlingActivity : false;
        if (isCargoActivity) {
          return this.calculateDeckSpaceForAfterCargoHandlingActivity(prevActivity, outboundVoyage, inboundVoyage, syncedAndUnsyncedOutboundCargoLines, syncedAndUnsyncedInboundCargoLines);
        }
        return prevActivity.deckSpaceUsed;
      }
      return this.calculateInitialDeckSpace(outboundVoyage);
    },
    calculateInitialDeckSpace(outboundVoyage) {
      if (outboundVoyage != null && outboundVoyage != undefined) {
        const margin = outboundVoyage.deckSpaceCargoMarginInMetres;
        const sum = outboundVoyage.cargoLines.length > 0 ? outboundVoyage.cargoLines.reduce((accumulator, cargoLine) => accumulator + this.calculateCargoLineSpace(cargoLine, margin), 0) : 0.0;
        var utilisation = (outboundVoyage.totalReservedDeckArea + sum) / outboundVoyage.totalVesselAvailableDeckSpace;

        return Math.round(utilisation * 100);
      }

      return 0.0;
    },
    calculateDeckSpaceForAfterCargoHandlingActivity(activityAfterCargoHandling, outboundVoyage, inboundVoyage, syncedAndUnsyncedOutboundCargoLines, syncedAndUnsyncedInboundCargoLines) {
      var deckSpace = 0.0;

      if (syncedAndUnsyncedOutboundCargoLines.length > 0 || syncedAndUnsyncedInboundCargoLines.length > 0) {
        var outboundMargin = outboundVoyage ? outboundVoyage.deckSpaceCargoMarginInMetres : 0.0;
        var inboundMargin = inboundVoyage ? inboundVoyage.deckSpaceCargoMarginInMetres : 0.0;

        var unLiftedOutboundCargoLines = syncedAndUnsyncedOutboundCargoLines.filter((x) => x.activityId === null && !x.isNob);
        var liftedInboundCargoLines = syncedAndUnsyncedInboundCargoLines.filter((x) => x.offshoreLiftTime && x.offshoreLiftTime <= activityAfterCargoHandling.endDateTimeLt && !x.isNob);

        var usedDeckSpace = unLiftedOutboundCargoLines.length > 0 ? unLiftedOutboundCargoLines.reduce((accumulator, cargoLine) => accumulator + this.calculateCargoLineSpace(cargoLine, outboundMargin, outboundVoyage.areSizesInMetres), 0) : 0.0;
        usedDeckSpace += liftedInboundCargoLines.length > 0 ? liftedInboundCargoLines.reduce((accumulator, cargoLine) => accumulator + this.calculateCargoLineSpace(cargoLine, inboundMargin, inboundVoyage.areSizesInMetres), 0) : 0.0;

        var anyOutboundCargoStillOnShip = unLiftedOutboundCargoLines.length > 0;
        deckSpace = this.calculateDeckSpace(usedDeckSpace, anyOutboundCargoStillOnShip, outboundVoyage, inboundVoyage);
      }
      return deckSpace;
    },
    calculateDeckSpace(usedDeckSpace, anyOutboundCargoStillOnShip, outboundVoyage, inboundVoyage) {
      var outboundVoyageNotNull = outboundVoyage != null && outboundVoyage != undefined;
      var deckSpace = 0.0;

      if (anyOutboundCargoStillOnShip && outboundVoyageNotNull) {
        usedDeckSpace += outboundVoyage.totalReservedDeckArea;
      }

      if (outboundVoyageNotNull) {
        deckSpace = this.calculateDeckSpaceWithVoyage(outboundVoyage, usedDeckSpace);
      }
      else {
        if (inboundVoyage != null && inboundVoyage != undefined) {
          deckSpace = this.calculateDeckSpaceWithVoyage(inboundVoyage, usedDeckSpace);
        }
        else {
          deckSpace = 0;
        }
      }
      return Math.round(deckSpace * 100)
    },
    calculateDeckSpaceWithVoyage(voyage, usedDeckSpace) {
      if (voyage.totalVesselAvailableDeckSpace > 0) {
        return usedDeckSpace / voyage.totalVesselAvailableDeckSpace;
      }
      else {
        return 0;
      }
    },
    recalculateDeckSpaceUsedForAllActivitiesOnVoyage(vesselActivities, outboundVoyage, inboundVoyage, syncedAndUnsyncedOutboundCargoLines, syncedAndUnsyncedInboundCargoLines) {
      for (var i = 0; i < vesselActivities.length; i++) {
        if (i === 0) {
          vesselActivities[i].deckSpaceUsed = this.calculateInitialDeckSpace(outboundVoyage);
        }
        else {
          const prevActivity = vesselActivities[i - 1];
          const { activity } = prevActivity;
          const isCargoActivity = activity ? activity.isCargoHandlingActivity : false;
          if (isCargoActivity) {
            vesselActivities[i].deckSpaceUsed = this.calculateDeckSpaceForAfterCargoHandlingActivity(vesselActivities[i], outboundVoyage, inboundVoyage, syncedAndUnsyncedOutboundCargoLines, syncedAndUnsyncedInboundCargoLines);
          }
          else {
            vesselActivities[i].deckSpaceUsed = prevActivity.deckSpaceUsed;
          }
        }
      }
      return vesselActivities;
    }
  },
};
